import * as instructorTypes from "Store/instructors/constants";

export const setInstructors = (instructors) => ({
  type: instructorTypes.SET_INSTRUCTORS,
  instructors
});

export const fetchInstructorSummary = (instructorId) => ({
  type: instructorTypes.HANDLE_FETCH_INSTRUCTOR_SUMMARY,
  instructorId
});

export const setInstructorSummary = (summary) => ({
  type: instructorTypes.SET_INSTRUCTOR_SUMMARY,
  summary
});

/* REFACTORED */

export const handleFetchInstructors = (): instructorTypes.IHandleFetchInstructors => ({
  type: instructorTypes.HANDLE_FETCH_INSTRUCTORS
});

export const handleDeactivateInstructor = (
  payload: DeactivateInstructorRequest,
  source: UpdateSource
): instructorTypes.IHandleDeactivateInstructor => ({
  type: instructorTypes.HANDLE_DEACTIVATE_INSTRUCTOR,
  payload,
  source
});

export const handleFetchInstructorStudents =
  (): instructorTypes.IHandleFetchInstructorStudents => ({
    type: instructorTypes.HANDLE_FETCH_INSTRUCTOR_STUDENTS
  });

export const setInstructorStudents = (
  payload: Student[]
): instructorTypes.ISetInstructorStudents => ({
  type: instructorTypes.SET_INSTRUCTOR_STUDENTS,
  payload
});

export const handleArchiveInstructor = (
  payload: ArchiveInstructorRequest,
  source: UpdateSource
): instructorTypes.IHandleArchiveInstructor => ({
  type: instructorTypes.HANDLE_ARCHIVE_INSTRUCTOR,
  payload,
  source
});

export const handleFetchInstructor = (
  instructorId: string
): instructorTypes.IHandleFetchInstructor => ({
  type: instructorTypes.HANDLE_FETCH_INSTRUCTOR,
  instructorId
});

export const handleCreateInstructor = (
  payload: CreateInstructorRequest
): instructorTypes.IHandleCreateInstructor => ({
  type: instructorTypes.HANDLE_CREATE_INSTRUCTOR,
  payload
});

export const handleUpdateInstructorInfo = (
  payload: UpdateInstructorInfoRequest
): instructorTypes.IHandleUpdateInstructorInfo => ({
  type: instructorTypes.HANDLE_UPDATE_INSTRUCTOR_INFO,
  payload
});

export const handleUpdateInstructorAddress = (
  payload: UpdateInstructorAddressRequest
): instructorTypes.IHandleUpdateInstructorAddress => ({
  type: instructorTypes.HANDLE_UPDATE_INSTRUCTOR_ADDRESS,
  payload
});

export const handleUpdateInstructor = (
  payload: UpdateInstructor
): instructorTypes.IHandleUpdateInstructor => ({
  type: instructorTypes.HANDLE_UPDATE_INSTRUCTOR,
  payload
});

export const handleFetchInstructorClassrooms = (
  instructorId: string
): instructorTypes.IHandleFetchInstructorClassrooms => ({
  type: instructorTypes.HANDLE_FETCH_INSTRUCTOR_CLASSROOMS,
  payload: instructorId
});

export const setInstructorClassrooms = (
  payload: Classroom[]
): instructorTypes.ISetInstructorClassrooms => ({
  type: "SET_INSTRUCTOR_CLASSROOMS",
  payload
});

export const handleFetchInstructorStats = (
  instructorId: string
): instructorTypes.IHandleFetchInstructorStats => ({
  type: "HANDLE_FETCH_INSTRUCTOR_STATS",
  payload: instructorId
});

export const setInstructorStats = (
  instructorStats: InstructorStats,
  instructorId: string
): instructorTypes.ISetInstructorStats => ({
  type: "SET_INSTRUCTOR_STATS",
  payload: {
    instructorId,
    instructorStats
  }
});

export const handleAddInstructorLocation = (
  payload: AddInstructorLocation
): instructorTypes.IHandleAddInstructorLocation => ({
  type: "HANDLE_ADD_INSTRUCTOR_LOCATION",
  payload
});

export const handleRemoveInstructorLocation = (
  payload: RemoveInstructorLocation
): instructorTypes.IHandleRemoveInstructorLocation => ({
  type: "HANDLE_REMOVE_INSTRUCTOR_LOCATION",
  payload
});

export const handleGrantFullAccess = (
  payload: FullAccessToOrganizationRequest
): instructorTypes.IGrantFullAccess => ({
  type: "HANDLE_GRANT_FULL_ACCESS",
  payload
});

export const handleRevokeFullAccess = (
  payload: FullAccessToOrganizationRequest
): instructorTypes.IRevokeEFullAccess => ({
  type: "HANDLE_REVOKE_FULL_ACCESS",
  payload
});

export const setInstructor = (payload: Instructor): instructorTypes.ISetInstructor => ({
  type: "SET_INSTRUCTOR",
  payload
});

export const setInstructorsSimplifiedLoading = (
  isLoading: boolean
): instructorTypes.ISetInstructorsSimplifiedLoading => ({
  type: "SET_INSTRUCTORS_SIMPLIFIED_LOADING",
  payload: {
    isLoading
  }
});
